import { getAllAmbulancesFailure, getAllAmbulancesSuccess,
  addNewAmbulanceFailure, addNewAmbulanceSuccess,
  editAmbulanceFailure, editAmbulanceSuccess,
  deleteAmbulanceSuccess, deleteAmbulancesFailure
 } from "../constants/ambulances"

 const initialState = {
  isProcessing: false,
  isError: false,
  addAmbulanceError: false,
  editAmbulanceError: false,
  deleteAmbulanceError: false,
  data: []
}

function handleReducer(state = initialState, action) {
  switch(action.type) {
    case getAllAmbulancesFailure:
      return {...state, isError: true};
    
    case getAllAmbulancesSuccess:
      return {...state, data: action.payload};

    case addNewAmbulanceFailure:
      return { ...state, addAmbulanceError: true };

    case addNewAmbulanceSuccess:
      return { ...state, data: [...state.data, action.payload] };

    case editAmbulanceFailure:
      return { ...state, editAmbulanceError: true };

    case editAmbulanceSuccess:
      return state;

    case deleteAmbulanceSuccess:
      return state;

    case deleteAmbulancesFailure:
      return { ...state, deleteAmbulanceError: true };

    default:
      return state;
  }
}

export const ambulanceReducer = (state, action) => {
  return handleReducer(state, action)
}